import React, { useContext } from "react";
import { Select } from "@flexisaf/flexibull2";
import PropTypes from "prop-types";
import styled from "styled-components";
import NaijaStates from "../../utils/naija-states-lga.js";

import { SchemaContext } from "../container";

const StateLgaGrid = styled.div.attrs({ className: "flex-render-state-lga" })`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem 1rem;
  width: 100%;
  margin: 0;
  padding: 0;
  align-items: start;

  & > * {
    min-width: 0;
    width: 100% !important;
  }

  /* Flexibull Select labels are absolute (top:-20px); keep them in flow here */
  & .flexi-select {
    display: flex !important;
    flex-direction: column !important;
    height: auto !important;
  }

  & .flexi-select-label,
  & label {
    position: static !important;
    top: auto !important;
    font-size: 0.7rem !important;
    font-weight: 600 !important;
    letter-spacing: 0.04em !important;
    text-transform: uppercase !important;
    color: #6a6378 !important;
    margin: 0 0 0.35rem !important;
    display: block !important;
  }
`;

const StateLGA = (props) => {
  const { disabledFields, errorFields, fieldValue, updateFieldValue } =
    useContext(SchemaContext);

  const updateValue = (key, val) => {
    if (disabledFields.includes(props.keyField)) return;
    const newVal = [...(fieldValue?.[props.keyField] || [])];
    newVal[key] = val;
    if (key === 0) newVal[1] = null;

    updateFieldValue(props.keyField, newVal);
  };

  const stateVal = fieldValue?.[props.keyField]?.[0] || null;
  const lgaVal = fieldValue?.[props.keyField]?.[1] || null;

  return (
    <StateLgaGrid>
      <Select
        style={{ width: "100%" }}
        placeholder="Select State"
        options={NaijaStates.states().map((s) => ({ label: s, value: s }))}
        value={stateVal ? { label: stateVal, value: stateVal } : null}
        onChange={({ value }) => updateValue(0, value)}
        label="State"
        required={props.props?.required}
        error={!stateVal && errorFields[props.keyField]}
        disable={disabledFields.includes(props.keyField)}
        spaceTop={0}
      />
      <Select
        style={{ width: "100%" }}
        placeholder="Select LGA"
        options={
          !stateVal
            ? []
            : NaijaStates.lgas(stateVal || "")
                ?.lgas?.sort()
                ?.map((s) => ({ label: s, value: s }))
        }
        value={lgaVal ? { label: lgaVal, value: lgaVal } : null}
        onChange={({ value }) => updateValue(1, value)}
        label="LGA"
        required={props.props?.required}
        error={!lgaVal && errorFields[props.keyField]}
        disable={disabledFields.includes(props.keyField)}
        spaceTop={0}
      />
    </StateLgaGrid>
  );
};

StateLGA.defaultProps = {
  label: null,
  placeholder: "Select option",
  helper: null,
  type: "text",
  required: false,
  rules: {
    validation: null,
    before: null,
  },
};

StateLGA.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  helper: PropTypes.string,
  type: PropTypes.string,
  rules: PropTypes.any,
  options: PropTypes.any,
};

export default StateLGA;
